var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeolocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.25 1.54499C7.08446 1.68121 5.97874 2.13503 5.05356 2.85688C4.12837 3.57874 3.41928 4.54089 3.00368 5.63831C2.58809 6.73572 2.48197 7.92622 2.69691 9.07985C2.91184 10.2335 3.43958 11.3059 4.2225 12.18L7.5 15.8175C7.68982 16.0268 7.92134 16.194 8.17968 16.3085C8.43801 16.423 8.71744 16.4821 9 16.4821C9.28256 16.4821 9.56199 16.423 9.82033 16.3085C10.0787 16.194 10.3102 16.0268 10.5 15.8175L13.7625 12.18C14.6256 11.2102 15.1741 10.0014 15.3353 8.71321C15.4966 7.42505 15.2631 6.11828 14.6656 4.96569C14.0682 3.81311 13.135 2.869 11.9895 2.25821C10.8439 1.64742 9.53995 1.39872 8.25 1.54499ZM9 10.3125C8.52353 10.314 8.05733 10.174 7.66043 9.9104C7.26353 9.64677 6.95379 9.27129 6.77042 8.83151C6.58705 8.39173 6.5383 7.90742 6.63035 7.43992C6.7224 6.97242 6.95109 6.54274 7.28749 6.2053C7.62388 5.86785 8.05284 5.63781 8.52006 5.54431C8.98727 5.45081 9.47172 5.49804 9.91207 5.68004C10.3524 5.86203 10.7289 6.1706 10.9937 6.56668C11.2586 6.96275 11.4 7.42851 11.4 7.90499C11.4 8.5422 11.1474 9.15342 10.6975 9.6047C10.2476 10.056 9.63721 10.3105 9 10.3125Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.38C10.4 10.38 11.535 9.24504 11.535 7.845C11.535 6.44496 10.4 5.31 9 5.31C7.59995 5.31 6.465 6.44496 6.465 7.845C6.465 9.24504 7.59995 10.38 9 10.38Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeolocation);
export default __webpack_public_path__ + "static/media/geolocation.7ad3dd70d0a59f702c220990b0c6caa2.svg";
export { ForwardRef as ReactComponent };